module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1p"
  }, [_c('a', {
    attrs: {
      "href": "#/itr"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("1. THE EVOLUTION OF AN ARCHETYPE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#chap1_sub1"
    }
  }, [_vm._v("Kronos the Titan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#chap1_sub2"
    }
  }, [_vm._v("The Mythic Kronos and the Roman Saturn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#chap1_sub3"
    }
  }, [_vm._v("The Old Malefic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#chap1_sub4"
    }
  }, [_vm._v("The Midwife of Insight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#chap1_sub5"
    }
  }, [_vm._v("The Alchemical Lead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#chap1_sub6"
    }
  }, [_vm._v("The Master of Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("2. THE NATURAL CYCLES OF SATURN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub1"
    }
  }, [_vm._v("A Journey towards Individuation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub2"
    }
  }, [_vm._v("Natal Saturn to Saturn Square (Birth-7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub3"
    }
  }, [_vm._v("Saturn Square to Saturn Opposition (7-14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub4"
    }
  }, [_vm._v("Saturn Opposition to Saturn Square (14-21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub5"
    }
  }, [_vm._v("Saturn Square to Saturn Return (22-29)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub6"
    }
  }, [_vm._v("Saturn Return to Saturn Square (29-36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub7"
    }
  }, [_vm._v("Saturn Square to Second Saturn Opposition (37-44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub8"
    }
  }, [_vm._v("Second Saturn Opposition to Saturn Square (45-52)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub9"
    }
  }, [_vm._v("Saturn Square to Second Saturn Return (52-59)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2#chap2_sub10"
    }
  }, [_vm._v("Second Saturn Return Onwards (from age 59)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("3. THE HEROIC ROUND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#chap3_sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heroism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#chap3_sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hamartia: The Hero and the Tragic Flaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#chap3_sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mythological Round")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#chap3_sub4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Angles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("4. THE PERSONAL HEROIC JOURNEY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Experiencing Boundaries, Definition and Containment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeing the Inside on the Outside")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Transit of Saturn over the Angles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Call to Adventure (MC)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Threshold Struggle (Asc.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Atonement (IC)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#chap4_sub7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Call to Return (Desc.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("5. THE TRANSIT OF SATURN TO THE PLANETS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#chap5_sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aspects: The Eye of Saturn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#chap5_sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#chap5_sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturn in Transit to Natal Planets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 69
// module chunks = 0